module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.7bcc6c9c.svg";